<template>
  <div
    v-if="initHasNext || initHasPrevious"
    class="container-fluid mt-5"
  >
    <div class="col-lg txt_seo mb-4">
      <slot name="seo-text1"></slot>
    </div>
    <nav>
      <ul class="pagination pagination-md pg-blue justify-content-center">
        <li
          v-if="initHasPrevious"
          class="page-item"
        >
          <a
            class="page-link"
            aria-label="Previous"
            :title="i18n.previous"
            @click="change(page - 1)"
          >
            <slot name="pagination-left-icon"></slot>
            <span class="sr-only">{{ i18n.previous }}</span>
          </a>
        </li>
        <li
          v-if="initHasPrevious"
          class="page-item"
        >
          <a
            :href="paginationFirstUrl"
            class="page-link"
          >
            1
          </a>
        </li>
        <li
          v-if="page - 1 > 1"
          class="page-item"
        >
          <span class="page-item">...</span>
        </li>
        <li class="page-item disabled">
          <a class="page-link">
            {{ page }} <span class="sr-only">({{ i18n.current }})</span>
          </a>
        </li>
        <li
          v-if="initHasNext"
          class="page-item"
        >
          <a
            class="page-link"
            aria-label="Next"
            :title="i18n.next"
            @click="change(page + 1)"
          >
            <slot name="pagination-right-icon"></slot>
            <span class="sr-only">{{ i18n.next }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import Url from 'domurl'

  export default {
    props: {
      initPage: {
        type: String,
        default: '1',
      },
      initHasNext: {
        type: Boolean,
        default: false,
      },
      initHasPrevious: {
        type: Boolean,
        default: false,
      },
      initBaseUrl: {
        type: String,
        default: null,
      },
      paginationFirstUrl: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        page: parseInt(this.initPage),
        query: {
          q: '',
          type: '',
          city: '',
          category: '',
          email: '',
          promoteFrom: '',
          promoteTo: '',
          expiringAd: '',
          expiredPromo: '',
          status: '',
          tags: '',
        },
        i18n: {
          next: gettext('Next'),
          previous: gettext('Previous'),
          current: gettext('Current'),
        },
      }
    },

    methods: {
      change(page) {
        let url = new Url(this.initBaseUrl)

        if (
          locations.language_prefix &&
          url.path.lastIndexOf(locations.language_prefix + '/', 0) !== 0
        ) {
          url.path = locations.language_prefix + url.path
        }

        for (let key in this.query) {
          this.query[key] = url.query[key]
        }

        url.clearQuery()

        for (let key in this.query) {
          if (this.query[key]) {
            url.query[key] = this.query[key]
          }
        }

        if (page > 1) {
          url.query.p = page
        }

        window.location = url
      },
    },
  }
</script>
